import React from 'react';
import PropTypes from 'prop-types';

// Banner que aparece en la parte superior cuando el usuario aún no ha dado permiso de notificaciones.
export default function BannerNotificaciones({ onActivar, cargando, onCerrar }) {
  return (
    <div style={{
      background: '#cc2222',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '10px 18px',
      fontSize: '14px',
      gap: '12px',
      flexWrap: 'wrap',
    }}>
      <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        🔔 <strong>Activa las notificaciones</strong> para recibir alertas de nuevos incidentes aunque la app esté cerrada.
      </span>
      <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
        <button
          onClick={onActivar}
          disabled={cargando}
          style={{
            background: '#fff',
            color: '#cc2222',
            border: 'none',
            borderRadius: '6px',
            padding: '6px 16px',
            fontWeight: 'bold',
            cursor: cargando ? 'wait' : 'pointer',
            fontSize: '13px',
          }}
        >
          {cargando ? 'Activando…' : 'Activar'}
        </button>
        <button
          onClick={onCerrar}
          style={{
            background: 'transparent',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.5)',
            borderRadius: '6px',
            padding: '6px 12px',
            cursor: 'pointer',
            fontSize: '13px',
          }}
        >
          Ahora no
        </button>
      </div>
    </div>
  );
}

BannerNotificaciones.propTypes = {
  onActivar: PropTypes.func.isRequired,
  cargando:  PropTypes.bool.isRequired,
  onCerrar:  PropTypes.func.isRequired,
};
